import { Inject, Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../domain/login/auth-version-2.service';
import { CoreAuthConfigService } from '@features/auth/core-auth-config.service';
import { StorageHelper } from '@features/auth/shared/helpers/storage.helper';
import { environment } from '@config/environments/environment';

@Injectable()
export class AuthRequestInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);
  private conf = inject(CoreAuthConfigService);

  private appKey: string = '';
  private tokenType: string = '';

  constructor() {
    this.appKey = this.conf.applicationConfig.appKey ?? '';
    this.tokenType = this.conf.applicationConfig.tokenType ?? '';
  }

  /**
 * Phương thức intercept được gọi mỗi khi có một HTTP request sắp được gửi đi.
 * Phương thức này sẽ thêm các header cần thiết vào request và trả về request đã được chỉnh sửa.
 *
 * @param request HttpRequest<any> - Đối tượng request ban đầu.
 * @param next HttpHandler - Bộ xử lý HTTP tiếp theo trong chuỗi xử lý.
 * @returns Observable<HttpEvent<any>> - Một Observable chứa các sự kiện HTTP.
 */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const { modifiedRequest, isSendAppKey } = this.prepareRequest(request);
    const appRequest = modifiedRequest.clone({
      setHeaders: this.getApplicationHeaders('true'),
    });

    return next.handle(appRequest);
  }

  /**
   * Xử lý request: lấy và xoá header 'use_appkey'
   * @param request HttpRequest<any> - Request ban đầu
   * @returns Object - Request đã chỉnh sửa và giá trị của 'use_appkey'
   * @private
   */
  private prepareRequest(request: HttpRequest<any>) {
    // TODO:
    const isSendAppKey = request.headers.get('use_appkey');
    const modifiedRequest = request.clone({
      headers: request.headers.delete('use_appkey'),
    });

    return { modifiedRequest, isSendAppKey };
  }

  /**
   * Tạo headers cho request
   * @param isSendAppKey string | null - Giá trị của 'use_appkey'
   * @returns Object - Headers cần thiết
   * @private
   */
  private getApplicationHeaders(isSendAppKey?: string | null): Record<string, string> {
    const headers: Record<string, string> = {
      Authorization: this.authService.buildTokenByJWTPrefix(this.tokenType),
    };

    // if (isSendAppKey === 'true') {
    // }
    this.appKey = StorageHelper.getAppKey()?.toString() || this.appKey.toString();

    // Truong hop khong phai production thi lay appKey tu environment
    if (!environment.production) {
      this.appKey = environment.authen.appKey
      console.warn('Running in non-production mode, using appKey from environment:', this.appKey);
    }

    headers['app-key'] = this.appKey;

    return headers;
  }
}
